'use client'

import WebbedHotelMarker from '@/components/googleMap/markers/WebbedHotelMarker';
import CustomMarker from '@/components/leaflet/CustomMarker';
import LeafletMapContainer from '@/components/leaflet/LeafletMapContainer';
import { NearByPlace } from '@/types/google';
import { useRef } from 'react';

export default function MapContainer({ center, hotel, }: { hotel: any, nearbys: NearByPlace[], center: { lat: number, lng: number }, restaurants: NearByPlace[], activity: NearByPlace[], landmarks: NearByPlace[] }) {
    const itemRefs = useRef<any>({});



    return (
        <div className="h-dvh md:h-auto md:aspect-[2.5/1] w-full  overflow-hidden
                         bg-gray-100 relative"
        >
            <LeafletMapContainer center={[center.lat, center.lng]}>

                <CustomMarker position={[hotel.lat, hotel.lng]}>
                    <WebbedHotelMarker icon place={hotel} isActive />
                </CustomMarker>

            </LeafletMapContainer>
        </div>
    );
}